// import Cookies from 'js-cookie'

const key = 'last_sync'

export function getLastSync() {
  // return Cookies.get(SyncKey)

  return localStorage.getItem(key)
}

export function setLastSync() {
  // return Cookies.set(SyncKey, new Date())

  return localStorage.setItem(key, new Date())
}

export function removeLastSync() {
  // return Cookies.remove(SyncKey)

  return localStorage.removeItem(key)
}
